import {IGetCatalogTransformedResponse} from 'modules/products/services';
import {IAppliedFilter} from 'plugins/modules/filter/helpers/BrowserFilters/AppliedFilters';
import {FilterType, IFilterFacetVariant} from 'plugins/modules/filter/types';
import {IBreadcrumb} from 'modules/seo/types';

export class ListingBreadCrumbs {
    constructor(filters: IAppliedFilter[], seo: IGetCatalogTransformedResponse['seo'], pathname: string) {
        this.filters = filters;
        this.pathname = pathname;
        this.seo = seo;
        this.setBasePath();
    }

    basePath = '';
    filters: IAppliedFilter[];
    filterBreadcrumbs: IBreadcrumb[] = [];
    pathname: string;

    seo: IGetCatalogTransformedResponse['seo'];

    getBreadcrumbsList() {
        this.setFilterBreadcrumbs();

        return this.filterBreadcrumbs;
    }

    // берём часть пути до сегмента filter вместо жёстко зашитого 'catalog',
    // чтобы работать с любым разделом листинга (catalog, stock, discount и т.д.)
    setBasePath() {
        const [pathBeforeFilter] = this.pathname.split('filter');

        this.basePath = pathBeforeFilter.endsWith('/') ? pathBeforeFilter : `${pathBeforeFilter}/`;
    }

    getRangeBreadcrumbs(
        minValue: number | null | undefined,
        maxValue: number | null | undefined,
        code: string,
        unit: string,
    ) {
        if (minValue && !maxValue) {
            return {
                url: `${this.getCategoriesPath()}filter/${code}-from-${minValue}/`,
                name: `От ${minValue} ${unit}`,
            };
        } else if (!minValue && maxValue) {
            return {
                url: `${this.getCategoriesPath()}filter/${code}-to-${maxValue}/`,
                name: `До ${maxValue} ${unit}`,
            };
        } else if (minValue && maxValue) {
            return {
                url: `${this.getCategoriesPath()}filter/${code}-from-${minValue}-to-${maxValue}/`,
                name: `${minValue} ${unit} - ${maxValue} ${unit}`,
            };
        }
        return null as any;
    }

    getOrBreadcrumbs(variant: IFilterFacetVariant | null, code: string, unit?: string) {
        if (!variant?.isApplied) {
            return null as any;
        }

        return {
            url: `${this.getCategoriesPath()}filter/${code}-${variant.code}`,
            name: `${variant.title} ${unit}`,
        };
    }

    getAndBreadcrumb(variant: IFilterFacetVariant | null, code: string, unit?: string) {
        if (!variant?.isApplied) {
            return null as any;
        }
        return {
            url: `${this.getCategoriesPath()}filter/${code}-${variant.code}`,
            name: `${variant.title} ${unit}`,
        };
    }

    getAloneBreadcrumb(code: string, name: string, unit?: string) {
        return {
            url: `${this.getCategoriesPath()}filter/${code}-1/`,
            name: `${name} ${unit}`,
        };
    }

    getCheckboxWithDescBreadcrumb(variant: IFilterFacetVariant | null, code: string, unit?: string) {
        if (!variant?.isApplied) {
            return null as any;
        }
        return {
            url: `${this.getCategoriesPath()}filter/${code}-${variant.code}/`,
            name: `${variant.title} ${unit}`,
        };
    }

    setFilterBreadcrumbs() {
        // eslint-disable-next-line
    const filterBreadcrumbs = this.filters.map(({ filter, variant }) => {
            const {type, title, code, minValue, maxValue, unit} = filter;

            switch (type) {
                case FilterType.RANGE:
                case FilterType.RANGE_WITH_GROUP:
                    return this.getRangeBreadcrumbs(minValue, maxValue, code, unit);

                case FilterType.CHECKBOX_OR:
                case FilterType.CHECKBOX_OR_WINERY:
                    return this.getOrBreadcrumbs(variant, code, unit);

                case FilterType.CHECKBOX_AND:
                    return this.getAndBreadcrumb(variant, code, unit);

                case FilterType.ALONE_CHECKBOX:
                    return this.getAloneBreadcrumb(code, title, unit);

                case FilterType.CHECKBOX_WITH_DESC:
                    return this.getCheckboxWithDescBreadcrumb(variant, code, unit);

                default:
                    return null as any;
            }
        });

        this.filterBreadcrumbs = filterBreadcrumbs.filter(Boolean);
    }

    getCategoriesPath() {
        return this.basePath;
    }
}
